import axios from "axios";
import appConfig from "../config/appConfig";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "../config/msalConfig";
import store from '../redux/store';

const BASE_URL = `${appConfig.apiUrl}api/Reports/`;

let msalInstance = null;
let userAccounts = [];

export const initializeAuth = async (instance, accounts) => {
  msalInstance = instance;
  userAccounts = accounts;
};

export const getAccessToken = async () => {
  if (!msalInstance) {
    console.error("MSAL instance is not available");
    return null;
  }

  if (!userAccounts || userAccounts.length === 0) {
    console.error("No accounts available");
    return null;
  }

  const account = userAccounts[0];
  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: account,
    });
    return response.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      try {
        const response = await msalInstance.acquireTokenPopup({
          ...loginRequest,
          account: account,
        });
        return response.accessToken;
      } catch (popupError) {
        console.error("Token acquisition via popup failed:", popupError);
        return null;
      }
    } else {
      console.error("Silent token acquisition failed:", error);
      return null;
    }
  }
};

export const fetchSecure = async (accessToken, apiEndpoint, options = {}) => {
  if (!accessToken) {
    console.error("Access token is not available");
    return null;
  }

  try {
    const response = await axios({
      method: options.method || "GET",
      url: apiEndpoint,
                headers: {
        Authorization: `Bearer ${accessToken}`,
        'Database-Source': getDbSrc(),
        ...options.headers,
      },
      data: options.data || null,
      params: options.params || null,
      responseType: options.responseType || "json",
    });
    return response.data;
  } catch (error) {
    console.error("API call failed:", error);
    return null;
  }
};

const getDbSrc = () => {
  const reduxStore = store.getState();
  return reduxStore.data.dbSrc;
}

export const getSearchResults = async (searchText, domain) => {
  console.log("Fetching tree...");
  const token = await getAccessToken();

  return await fetchSecure(token, `${BASE_URL}tree?searchText=${searchText}&domain=${domain}`);
};

export const getTreeById = async (rulesetGroupId) => {
  console.log("Fetching tree...");
  const token = await getAccessToken();

  return await fetchSecure(token, `${BASE_URL}treebyid?rulesetGroupId=${rulesetGroupId}`);
};

export const getValidationById = async (validationId) => {
  console.log("Fetching validation...");
 const token = await getAccessToken();

 return await fetchSecure(token, `${BASE_URL}report/${validationId}`);
};

export const getItemById = async (ruleId) => {
  const accessToken = await getAccessToken();
  const url = `${BASE_URL}byid?ruleId=${ruleId}`;
  const rules = await fetchSecure(accessToken, url);

  return rules || {};      
};

export const getLastestValidations = async (pageNum = 1, pageSize = 12) => {
  const accessToken = await getAccessToken();
  const url = `${BASE_URL}reports?page=${pageNum}&pageSize=${pageSize}`;
  const validations = await fetchSecure(accessToken, url);

  return validations || [];     
}

export const getValidationsByFilter = async (filter = '', value = '', value2 = '', pageNum = 1, pageSize = 12) => {
  const accessToken = await getAccessToken();
  const url = filter != 'Date' ?
    `${BASE_URL}reports?${filter}=${value}&page=${pageNum}&pageSize=${pageSize}` :
    `${BASE_URL}reports?StartDate=${value}&EndDate=${value2}&page=${pageNum}&pageSize=${pageSize}`;
  const validations = await fetchSecure(accessToken, url);


  return validations || [];     
}


